import { useGlobalQuery } from 'state/query-client/hooks';
import { getLlmModels } from '../services/llm-model-service';
import { useConfig } from 'hooks/use-config';

export const useGetLlmModel = () => {
  const { configurationSettings } = useConfig();

  return useGlobalQuery({
    queryKey: ['getLlmModel'],
    queryFn: () => getLlmModels(configurationSettings),
  });
};
